import type RibbonViewState from '../store/schema/RibbonViewState';
import type { IPoint } from '@fluentui/react/lib/Utilities';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setContextualFormatBarTarget',
    (ribbonViewState: RibbonViewState, targetPoint: IPoint) => {
        ribbonViewState.targetPoint = targetPoint;
    }
);
